// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { z } from 'zod';

/**
 * Schema for inventory transfer response.
 */
const moveInventoryResponseSchema = z.object({
  data: z.object({
    success: z.boolean(),
  }),
  metadata: responseMetadataSchema,
});

type MoveInventoryResponse = z.infer<typeof moveInventoryResponseSchema>;

/**
 * Transfers inventory between locations.
 *
 * @param params Object containing itemId, originId, destinationId, quantity
 * @returns Promise resolving to success status
 */
export async function moveInventory(params: {
  itemId: string;
  originId: string;
  destinationId: string;
  quantity: number;
  note?: string;
}): Promise<MoveInventoryResponse> {
  const { note, ...rest } = params;
  const data = note ? { ...rest, note } : rest;

  const url = '/v1/item-move';
  const response = await api.post(url, data);
  return parseResponse(moveInventoryResponseSchema, response.data, {
    schemaName: 'MoveInventory',
    endpoint: url,
  });
}
